export const config = {
  url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTvcwdbMIWMtZx0rIDb04XKFVNpVepHs2FCHhxKHAUDuIiupB3LqEJtR8ySj8vlv3oSocCApO3FyTl4/pub?gid=1121863595&single=true&output=csv",
  // title: "Virginia Tech Authors 2019-2022",
  // description: "A listing of all of the publications by Virginia Tech employees over the last 3 years",
  searchFields: [
    "Dept",
    "Course No",
    "Instructor",
    "Book Title",
    "ISBN",
    "Provider",
  ],
  headers: [
    {
      key: "Dept",
      value: "Department",
    },
    {
      key: "Course No",
      value: "Course Number",
    },
    {
      key: "Instructor",
      value: "Instructor",
    },
    {
      key: "Book Title",
      value: "Book Title",
    },
    {
      key: "ISBN",
      value: "ISBN",
    },
    {
      key: "Provider",
      value: "Provider",
    },
    {
      key: "Access",
      value: "Access",
    },
  ],
  link: {
    url: "Link",
    field: "Book Title",
  },
  expandable: false,
};
